import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import Popup from 'components/popups/Popup'
import { useReduxSelector } from 'store'
import KeyReturn from './KeyReturn'
import React from 'react'

interface KeyReturnPopupProps {
  warehouseId: string
}

const KeyReturnPopup: React.FC<KeyReturnPopupProps> = ({ warehouseId }) => {
  const { keyReturn } = useReduxSelector(state => selectWarehouse(state, warehouseId))

  return (
    <Popup>
      <div className='popup__keyReturn'>
        <KeyReturn keyReturn={keyReturn} />
      </div>
    </Popup>
  )
}

export default KeyReturnPopup
